<template>
  <div class="auth">
    <div class="form-container">
      <router-link to="/" class="logo-link">
        <Logo />
      </router-link>
      <div class="form">
        <RouterView />
      </div>
    </div>
    <div class="app-preview">
      <div class="image"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Logo } from '@tallo/design-system';
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.auth {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;

  .form-container {
    display: flex;
    flex-direction: column;

    width: 100%;
    height: 100%;
    padding: var(--t-spacing-xl) var(--t-spacing-lg);
    max-width: 30rem;

    background-color: var(--t-color-neutral-white);
  }

  .logo-link {
    width: fit-content;
  }

  .form {
    max-width: 25rem; // google button can't be wider than 25rem
    width: 100%;
    margin: auto;
  }

  .app-preview {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-grow: 1;

    padding-block: 5vh;
    padding-inline-start: 10vh;
  }

  .image {
    width: 100%;
    height: 100%;
    background-image: url('/assets/app-preview.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center right;
  }

  @include desktop {
    .form-container {
      max-width: 37.5rem;
    }
  }

  @include tablet {
    .form-container {
      max-width: 100%;
    }

    .app-preview {
      display: none;
    }
  }

  @include screen-min-3xl {
    .form-container,
    .app-preview {
      width: 50%;
      max-width: 50%;
    }
  }
}
</style>
